import { Controller, useForm } from "react-hook-form";
import styled from "styled-components";
import Row from "./Row";
import { ButtonBase } from "./Buttons";
import { FaSearch, FaTimes } from "react-icons/fa";
import theme from "../common/theme";

const Input = styled.input`
    flex: 1;
    outline: none;
    font-size: 14px;
    font-family: "Roboto Condensed";
    font-weight: 400;
    border: none;
    background: ${theme.palette.light};
`

const Form = styled.form`
    padding: 0;
    margin: 0;
    display: flex;
    flex: 1;
`

const Search = ({ onSubmit, style }) => {
    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: { search: "" },
    });

    const localSubmit = (values) => {
        reset({ search: "" })
        onSubmit(values);
    }

    return (
        <Form onSubmit={handleSubmit(localSubmit)} autoComplete="false">
            <Controller
                name="search"
                control={control}
                render={({ field: { ...fieldProps } }) => (
                    <Input {...fieldProps} placeholder="Enter Search..." style={style} autoComplete="none" type="search" />
                )}
            />
        </Form>
    )
}


export const StyledSearch = ({ onResetClick, ...props }) => (
    <Row style={{ flex: 1, backgroundColor: theme.palette.light, padding: '0.5rem 1rem', ...props.containerStyle }}>
        <FaSearch />
        <Search style={{ border: 'none', background: 'none' }} {...props} />
        <ButtonBase style={{ padding: "0.5rem" }} onClick={onResetClick}>
            <FaTimes color="#000" />
        </ButtonBase>
    </Row>
)

export default Search;


